import { EditableCellTypes } from './CuesheetConstants';
import CuesheetDataHelper from './CuesheetDataHelper';
import { Map } from 'immutable';

/**
 * TODO: search for these function names in CuesheetCursorMixin and replace them ... these were pulled out for reusability and to make the functionality testable
 *
 */

/**
 * Get the row index/position, given the ids
 *
 * @param {*} itemSetId
 * @param {*} rowId
 * @param {*} state
 */
export function findRowPosition(itemSetId, rowId, state) {
  let rows = state.get('rows');

  if (!rows) return -1;

  return rows.findIndex(
    (rowSpec) =>
      rowSpec.get('path')[0] === itemSetId && rowSpec.get('path')[2] === rowId,
  );
}

/**
 * Get the editing cell info
 *
 * @param {*} state
 */
export function getEditingPosition(state) {
  if (!state.get('rows')) return null;

  const editingRowIndex = state
    .get('rows')
    .findIndex((row) => row.get('editing'));

  if (editingRowIndex === -1) return null;

  const editingRow = state.getIn(['rows', editingRowIndex]);

  const cellSpec = Map.isMap(editingRow.get('editing'))
    ? editingRow.get('editing').toJS()
    : editingRow.get('editing');

  return {
    cellSpec,
    rowIndex: editingRowIndex,
    rowId: editingRow.get('path')[2],
  };
}

/**
 * Get the current cursor position
 *
 * @param {*} state
 */
export function getCursorPosition(state, shiftKeyPressed) {
  if (!state.get('rowMap')) return null;

  const itemSetId = state.get('rowMap').keySeq().first();

  if (!state.get('selectedCells')) return null;
  if (!state.get('selectedCells').size) return null;

  /**
   * If no selected cells return default selected cell
   */
  const { rowId, cellSpec } = !shiftKeyPressed
    ? getFirstSelectedCell(state)
    : getSelectedCell(state, false);

  return {
    cellSpec,
    rowIndex: findRowPosition(itemSetId, rowId, state),
    rowId,
  };
}

/**
 * Get the first selected cell
 * @param {} state
 */
export function getFirstSelectedCell(state) {
  if (!state.get('selectedCells') || state.get('selectedCells').size < 1)
    return -1;

  const { rowId, cellSpec } = state.get('selectedCells').first(),
    itemSetId = state.get('rowMap').keySeq().first();

  return {
    rowIndex: findRowPosition(itemSetId, rowId, state),
    rowId,
    cellSpec,
  };
}

/**
 * Get the selected cell
 *
 * @param {*} state
 * @param {*} allowDefault if true, private a "default" selected cell in the event there is no cursor position
 */
export function getSelectedCell(state, allowDefault) {
  const rowIndex = getLastSelectedCellRowIndex(state);

  if (rowIndex === -1)
    return allowDefault ? _getDefaultSelectedCell(state) : null;

  return getLastSelectedCell(state);
}

/**
 * Get the row index of the last selected cell
 *
 * @param {*} state
 */
export function getLastSelectedCellRowIndex(state) {
  const cell = getLastSelectedCell(state);

  if (cell === -1) return -1;

  return cell.rowIndex;
}

/**
 * Get the last selected cell
 * @param {} state
 */
export function getLastSelectedCell(state) {
  if (!state.get('selectedCells')) return -1;
  if (state.get('selectedCells').size < 1) return -1;

  const selectedCells = state.get('selectedCells');

  const { rowId, cellSpec } = selectedCells.last(),
    itemSetId = state.get('rowMap').keySeq().first();

  return {
    rowIndex: findRowPosition(itemSetId, rowId, state),
    rowId,
    cellSpec,
  };
}

function _getDefaultSelectedCell(state) {
  const rowIndex = 0,
    rowId = CuesheetDataHelper.findRowId(0, state);

  return {
    rowIndex,
    rowId,
    cellSpec: { type: EditableCellTypes.ItemTitle },
    default: true,
  };
}
